import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { stripLang } from "@/lib/i18n";

const SITE = "Moga 360";
const DEFAULT_TITLE = "Moga 360 · Verified local businesses of Moga";
const DEFAULT_DESC = "Find physically verified plumbers, electricians, tutors, shops and more in Moga, Punjab. Call or WhatsApp in one tap.";

const upsert = (tag, key, val, attrs) => {
  let el = document.head.querySelector(`${tag}[${key}="${val}"]`);
  if (!el) {
    el = document.createElement(tag);
    el.setAttribute(key, val);
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};

const setAlternates = (o, base) => {
  document.head.querySelectorAll("link[data-seo-alt]").forEach((e) => e.remove());
  [["en", ""], ["pa", "/pa"], ["hi", "/hi"], ["x-default", ""]].forEach(([hl, p]) => {
    const l = document.createElement("link");
    l.rel = "alternate";
    l.hreflang = hl;
    l.href = `${o}${p}${p && base === "/" ? "" : base}`;
    l.dataset.seoAlt = "1";
    document.head.appendChild(l);
  });
};

const setJsonLd = (ld) => {
  let s = document.getElementById("seo-jsonld");
  if (!ld) { s?.remove(); return; }
  if (!s) {
    s = document.createElement("script");
    s.type = "application/ld+json";
    s.id = "seo-jsonld";
    document.head.appendChild(s);
  }
  s.textContent = ld;
};

export const Seo = ({ title, description, image, canonical, jsonLd, noindex = false }) => {
  const { pathname } = useLocation();
  const ld = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    const o = window.location.origin;
    const full = title ? `${title} | ${SITE}` : DEFAULT_TITLE;
    const desc = description || DEFAULT_DESC;
    const url = canonical || `${o}${pathname}`;
    document.title = full;
    upsert("meta", "name", "description", { content: desc });
    upsert("meta", "name", "robots", { content: noindex ? "noindex,follow" : "index,follow" });
    upsert("meta", "name", "twitter:card", { content: "summary_large_image" });
    [["og:title", full], ["og:description", desc], ["og:url", url], ["og:type", "website"], ["og:site_name", SITE],
      ["og:image", image || `${o}/moga/m0.jpg`]].forEach(([p, c]) => upsert("meta", "property", p, { content: c }));
    upsert("link", "rel", "canonical", { href: url });
    setAlternates(o, stripLang(pathname));
    setJsonLd(ld);
  }, [title, description, image, canonical, ld, noindex, pathname]);
  return null;
};
